import React, { CSSProperties, useRef, useState } from "react";
import cx from "classnames";
import styles from "./avatar-input.module.scss";
import { api } from "shared/api";
import { Avatar } from "../avatar";

export interface IAvatarInput {
  id: string;
  name: string;
  size: number;

  value?: string;
  onChange: (value?: string) => void;
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
  tabIndex?: number;
}

export const AvatarInput = (props: IAvatarInput) => {
  const image = api.image.useImageImage(props.value!);

  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    inputRef.current?.click();
  };

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (loading) return;
    setLoading(true);
    try {
      const image = e.target.files?.[0];
      const { id } = await api.image.imageUploadImage(image);
      if (inputRef.current) inputRef.current.value = "";
      await props.onChange(id);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cx(styles.avatar_input, props.className)} style={props.style} id={props.htmlId}>
      <button onClick={onClick} tabIndex={props.tabIndex}>
        <Avatar id={props.id} name={props.name} image={image.data} size={90} className={styles.avatar} />
      </button>
      <input type="file" onChangeCapture={onChange} ref={inputRef} className={styles.input} />
    </div>
  );
};

AvatarInput.defaultProps = {
  size: 78,
};
